import _ from 'lodash';

const sortCases = (cases, value) => {
  switch (value) {
    case 0:
      return _.orderBy(cases, ['partOneGeneralInformation.firstName'], ['asc']);
    case 1:
      return _.orderBy(cases, ['partOneGeneralInformation.lastName'], ['asc']);
    case 2:
      return _.orderBy(cases, ['metaData.dateCreated', 'partOneGeneralInformation.lastName'], ['asc', 'asc']);
    case 3:
      return _.orderBy(cases, ['status', 'metaData.dateCreated'], ['asc', 'asc']);

    default:
      return cases;
  }
};

export default sortCases;
